import stringInject from 'stringinject'
import {KEY_API} from '../config/config_api_backend'
import http from '../plugins/http'

const apiGetAllApplication = async () => {
    try {
        let url = stringInject(KEY_API.GET_ALL_APP)
        let response = await http.get(url)
        return response.data
    } catch(e) {
        if (e.response && e.response.status !== 204) return null
        else return []
    }
}

const apiGetApplication = async (id) => {
    try {
        let url = stringInject(KEY_API.GET_APP, id)
        let response = await http.get(url)
        return response.data
    } catch(e) {
        if (e.response && e.response.status !== 204) return null
        else return {}
    }
}

const apiCreateApiKey = async (data) => {
    try {
        const formData = new FormData()
        formData.append('name', data.name)
        formData.append('status_url', data.statusUrl)
        formData.append('complete_url', data.completeUrl)
        formData.append('update_url', data.updateUrl)
        let response = await http.put(KEY_API.PUT_NEW_APP, formData, {'Content-Type': 'multipart/form-data'})
        return response.data
    } catch(e) {
        console.log(e)
        return null
    }
}

const apiUpdateApiKey = async (data) => {
    try {
        const url = stringInject(KEY_API.UPDATE, {'id': data.id})
        const formData = new FormData()
        formData.append('status_url', data.statusUrl)
        formData.append('complete_url', data.completeUrl)
        formData.append('update_url', data.updateUrl)
        let response = await http.post(url, formData, {'Content-Type': 'multipart/form-data'})
        return response.data
    } catch(e) {
        console.log(e)
        return null
    }
}

const apiRegenerateKeyApi = async (id) => {
    try {
        let url = stringInject(KEY_API.REGENERATE, {'id': id})
        let response = await http.post(url)
        return response.data
    } catch(e) {
        console.log(e)
        return null
    }
}

const apiDeleteKeyApi = async (id) => {
    try {
        let url = stringInject(KEY_API.REGENERATE, {'id': id})
        let response = await http.delete(url)
        return response.data
    } catch (e) {
        console.log(e)
        return null
    }
}

export {
    apiGetAllApplication,
    apiGetApplication,
    apiCreateApiKey,
    apiUpdateApiKey,
    apiRegenerateKeyApi,
    apiDeleteKeyApi
}